import { SET_LOAD, CLOSE_LOAD } from "./type";

export const setLoad = (message) => ({ type: SET_LOAD, payload: message });

export const closeLoad = () => ({ type: CLOSE_LOAD, payload: {} });
